import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import profileServices from './profileServices';

// Iniital State for Billing
const initialState = {
  profile: null,
  isError: false,
  isSuccess: false,
  isExchanged: false,
  isLoading: false,
  isExchanging: false,
  isSaving: true,
  message: '',
};

// Profile Slice
export const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    reset: state => {
      state.isLoading = false;
      state.isExchanging = false;
      state.isSuccess = false;
      state.isError = false;
      state.isSaving = false;
      state.message = '';
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getProfile.pending, state => {
        state.isLoading = true;
      })
      .addCase(getProfile.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.profile = payload;
      })
      .addCase(getProfile.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isError = true;
        state.message = payload;
        state.profile = null;
      })
      .addCase(exchangeContact.pending, state => {
        state.isExchanging = true;
      })
      .addCase(exchangeContact.fulfilled, (state, { payload }) => {
        state.isExchanging = false;
        state.isExchanged = true;
        state.message = payload;
      })
      .addCase(exchangeContact.rejected, (state, { payload }) => {
        state.isExchanging = false;
        state.isError = true;
        state.message = payload;
        state.profile = null;
      });
  },
});

// Get profile
export const getProfile = createAsyncThunk(
  'profile',
  async (profileId, thunkAPI) => {
    try {
      return await profileServices.profile(profileId);
    } catch (error) {
      let message;
      if (error.code === 'ERR_NETWORK') {
        message = error.message;
      } else if (error.response) {
        message = error.response.data.message;
      }
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Exchange Contact
export const exchangeContact = createAsyncThunk(
  'exchange/contact',
  async (exchangeData, thunkAPI) => {
    try {
      return await profileServices.exchangeContact(exchangeData);
    } catch (error) {
      console.log('error', error);
      let message;
      if (error.code === 'ERR_NETWORK') {
        message = error.message;
      } else if (error.response) {
        message = error.response.data.status;
      }
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Exports
export const { reset } = profileSlice.actions;

export default profileSlice.reducer;
